import { render, staticRenderFns } from "./ContactsCardCountActions.vue?vue&type=template&id=374aeda8&"
import script from "./ContactsCardCountActions.vue?vue&type=script&lang=js&"
export * from "./ContactsCardCountActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports